import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./contrato-listar/contrato-listar.module').then(m => m.ContratoListarModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./contrato-editar/contrato-editar.module').then(m => m.ContratoEditarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./contrato-inserir/contrato-inserir.module').then(m => m.ContratoInserirModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./contrato-detalhar/contrato-detalhar.module').then(m => m.ContratoDetalharModule) }
    ])],
    exports: [RouterModule]
})
export class ContratoAppRoutingModule { }